import { fetchSvedocenja } from '../fetch/documents';
import { createReducer } from './createReducer';
const svedocenjaSlice = createReducer("svedocenja", fetchSvedocenja);


export const selectSvedocenja = (state) => state.svedocenja.value
export const selectLoadingSvedocenja = (state) => state.svedocenja.isLoading
//export const selectPageSvedocenja = (state) => state.recentDocuments.page;

export const {} = svedocenjaSlice.actions

export default svedocenjaSlice.reducer

